import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Image,
  Portal,
  Radio,
  RadioGroup,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import RemitaPayment from "react-remita";
import { useNavigate, useParams } from "react-router-dom";
import purse from "../../../img/purse.svg";
import remita from "../../../img/remita.svg";
import { IAllCourse } from "../../../models/allcourse.model";
import { IUser } from "../../../models/auth.model";
import { ICourseEnrol } from "../../../models/course-enrolment.model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import routes from "../../../pages/routes";
import {
  getLocalUserProfile,
  getUserWallet,
} from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import coursesService from "../../../services/courses.service";
import paymentService from "../../../services/payment.service";
import registrationService from "../../../services/registration.service";

const VerifyPayment = ({ prePage, ...rest }: { prePage: any }) => {
  const navigate = useNavigate();
  const { course_id } = useParams();
  const { enrolment_id } = useParams();
  const [course, setCourse] = useState<IAllCourse>();
  const [user, setUser] = useState<IUser | null>();
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const [value, setValue] = useState("2");
  const [amount, setAmount] = useState("");
  const [availableCourse, setAvailableCourses] = useState<
    IAvailableCourse[] | any
  >();
  const [userWallet, setUserWallet] = useState<any>();
  const [transactionid, setTransactionId] = useState("");
  const [paymentData, setpaymentData] = useState({});
  const [isOpenAlert, setIsOpen] = useState(false);
  const onCloseAlert = () => setIsOpen(false);
  const cancelRef = useRef(null);

  const confirmAlert = () => {
    initiatepayment();
    setIsOpen(true);
  };

  useEffect(() => {
    const user = getLocalUserProfile();
    const amount = localStorage.getItem("course_amount");
    if (amount) setAmount(amount);
    if (user) {
      getUserWallet(user.uuid).then((res) => {
        if (res) {
          setUserWallet(res.available_balance);
        }
      });
    }
    setUser(user);

    coursesService
      .getAvailableCourses()
      .then((response) => {
        const available_course: IAvailableCourse[] | any = response.find(
          (each) => each.course.uuid === course_id
        );
        setAvailableCourses(available_course);

        setLoading(false);
      })
      .catch((err) => err);

    registrationService
      .getEachCourse(course_id)
      .then((response) => {
        setLoading(false);
        console.log(response, "Jebooooo");
        setCourse(response);
        if (user) {
          const nameArray = user.name.split(" ");
          setpaymentData({
            key: "QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=",
            customerId: `${user.email}`,
            firstName: `${nameArray[0]}`,
            lastName: `${nameArray[1]}`,
            email: `${user.email}`,
            // amount: `${response.cost}`,
            amount: `${amount}`,
            narration: `Payment for ${response.name.toLowerCase()}`,
          });
        }

        setLoading(false);
      })
      .catch((err) => err);
  }, [availableCourse]);

  const data = {
    ...paymentData,
    onSuccess: function (response: any) {
      // function callback when payment is successful
      if (response) {
        console.log(response, "Heyyy did this run ???");
        console.log(response.transactionId, "No whine me oo"); // no transaction id here so where can i get the transaction id
        setTransactionId(response?.transactionId);
        confirmPayment(response?.transactionId);
      }
    },
    onError: function (response: any) {
      // function callback when payment fails

      if (response) {
        const confirm = {
          payment_id: response.transactionId,
          status: "failed",
        };
      }
    },
    onClose: function () {
      // function callback when payment modal is closed
    },
  };

  const confirmPayment = (transactionId: any) => {
    const paymentid = localStorage.getItem("paymentId");

    if (paymentid) {
      const confirm = {
        payment_id: paymentid.toString(),
        process_id: transactionId, // check for transaction
        status: "confirmed",
      };
      paymentService.confirmPayment(confirm).then((res) => {
        if (res.message == "Payment confirmed successfully") {
          navigate(routes.successfulPayment);
        }
      });
    }
  };

  const enrolCourse = (paymentId: number) => {
    if (course && availableCourse !== undefined) {
      let enrolCourseData: ICourseEnrol;
      parseInt(amount) < course.cost
        ? (enrolCourseData = {
            centre_1_id: "1",
            payment_ids: paymentId.toString(),
            payment_mode: "Part",
            enrolled_by: user ? user.id.toString() : "",
            course_session_id: availableCourse?.session_id.toString(),
            course_term_id: availableCourse?.term_id.toString(),
          })
        : (enrolCourseData = {
            centre_1_id: "1",
            payment_ids: paymentId.toString(),
            payment_mode: "Full",
            enrolled_by: user?.id.toString(),
            course_session_id: availableCourse?.session_id.toString(),
            course_term_id: availableCourse?.term_id.toString(),
          });

      courseEnrolmentService
        .enrolCourse(enrolCourseData, course.uuid)
        .then((res) => {
          localStorage.removeItem("course_amount");
          localStorage.removeItem("page_payment_no");
          localStorage.removeItem("paymentId");
        });
    }
  };

  const initiatepayment = () => {
    let data: any;
    value == "2" && enrolment_id
      ? (data = {
          type: "enrollment",
          type_id: parseInt(enrolment_id),
          amount: amount,
          processor: "remita",
        })
      : (data = {
          type: "wallet-credit",
          amount: amount,
          processor: "wallet",
        });

    paymentService.inititatePayment(data).then((res) => {
      localStorage.setItem("paymentId", res.data.id);
      // setTransactionId(res.data.id)
    });
  };

  return (
    <Box px={6} mb="50px">
      <Flex justifyContent="center" mt="60px" mb="35px">
        <Text mx="auto" color="#616161" fontSize="20px" fontWeight="700">
          Confirm Payment
        </Text>
      </Flex>

      <Box py="8px" borderRadius="8px" boxShadow="base">
        <Flex
          justifyContent="space-between"
          pt="25px"
          pb="15px"
          px="30"
          borderBottom="1px solid"
          borderColor="lightgray"
        >
          <Text>Training Program</Text>
          <Text textTransform="capitalize">{course?.name.toLowerCase()}</Text>
        </Flex>
        <Flex
          justifyContent="space-between"
          pt="25px"
          pb="15px"
          px="30"
          borderBottom="1px solid"
          borderColor="lightgray"
        >
          <Text>Total Transaction Amount (NGN):</Text>
          <Text>
            <NumericFormat
              value={amount}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"₦"}
            />
          </Text>
        </Flex>
        <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
          <Text>Allowed Number of Installment :</Text>
          <Text>{course?.installment}</Text>
        </Flex>
      </Box>
      <Box py="8px" borderRadius="8px" boxShadow="base">
        <Flex pt="25px" pb="15px" px="30">
          <Text>Select Payment Method</Text>
        </Flex>
        <RadioGroup onChange={setValue} value={value}>
          <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
            <Radio colorScheme="red" value="1" isDisabled>
              Wallet (Balance:
              {
                <NumericFormat
                  value={userWallet}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"₦"}
                />
              }
              ){" "}
              <Text as="span" color="red.300">
                coming soon
              </Text>
            </Radio>
            <Image width="80px" height="20px" src={purse} />
          </Flex>
          <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
            <Radio colorScheme="red" value="2">
              Remita Web Pay
            </Radio>
            <Image src={remita} />
          </Flex>
        </RadioGroup>
      </Box>
      <Box width="200px" mx="auto">
        <Flex justifyContent="center" flexDirection="column">
          <Text mx="auto" pt="30px" pb="20px" fontSize="14px" color="#616161">
            Supported Options
          </Text>
          <Box mx="auto">
            {" "}
            <Image src={remita} />
          </Box>
          {value == "2" ? (
            <Box
              pl="30px"
              onClick={() => {
                initiatepayment();
              }}
              mt="20px"
            >
              <RemitaPayment
                remitaData={data}
                className="btn" // class to style the button
                text="PAY NOW" //text to show on button
                // add a 'live' prop to use the live urls/keys
              />
            </Box>
          ) : (
            <Button
              fontWeight={"400"}
              fontSize={"14px"}
              onClick={() => confirmAlert()}
              isDisabled={parseInt(amount) > parseInt(userWallet)}
              colorScheme={"red"}
              mt="20px"
            >
              INITIATE PAYMENT
            </Button>
          )}
        </Flex>
      </Box>

      <Portal>
        <AlertDialog
          isOpen={isOpenAlert}
          leastDestructiveRef={cancelRef}
          onClose={onCloseAlert}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="md" fontWeight="semibold">
                Confirm Payment
              </AlertDialogHeader>

              <AlertDialogBody fontSize={15}>
                Are you sure? You can't undo this action afterwards.
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button size={"sm"} ref={cancelRef} onClick={onCloseAlert}>
                  Cancel
                </Button>
                <Button
                  size={"sm"}
                  colorScheme="red"
                  onClick={confirmPayment}
                  ml={3}
                >
                  Confirm
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Portal>
    </Box>
  );
};

export default VerifyPayment;
